import React, { useState } from 'react';
import classNames from 'classnames';
import Icons from '../../components/Icons/Icons';
import { NamedLink } from '../../components';
import { DreamHomePageTab } from '../../util/enums';
import { useSelector } from 'react-redux';
import { getFaqs } from '../../ducks/strapi.duck';
import { isArrayLength } from '../../util/genericHelpers';

import css from './CustomerLandingPage.module.css';

function SectionFAQ({ intl }) {
  const faqsData = useSelector(getFaqs);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={css.faqContentWrapper}>
      <div className={css.fixedWidthContainer}>
        <div className={css.mainTitle}>
          <h2>{intl.formatMessage({ id: 'SectionFAQ.header' })}</h2>
        </div>
        <div className={css.faqContent}>
          {isArrayLength(faqsData)
            ? faqsData.map((faq, index) => (
                <div
                  key={index}
                  className={classNames(css.faqCard, {
                    [css.activeFAQ]: activeIndex === index,
                  })}
                  onClick={() => handleAccordionClick(index)}
                >
                  <div className={css.faqBody}>
                    <span className={css.faqHeading}>{faq?.question}</span>
                    {activeIndex === index && (
                      <div className={css.faqDescription}>{faq?.answer}</div>
                    )}
                  </div>
                  <span className={css.faqIcon}>
                    {activeIndex === index ? <Icons name="upAngle" /> : <Icons name="downAngle" />}
                  </span>
                </div>
              ))
            : null}
        </div>
        <p className={css.help}>
          For any further assistance{' '}
          <NamedLink
            name="DreamHomePage"
            params={{ tab: DreamHomePageTab.PLOT_DETAILS }}
            className={css.getStarted}
          >
            {intl.formatMessage({ id: 'CustomerLandingPage.ProjectBrief.Button' })}{' '}
            <Icons name="rightArrow" />
          </NamedLink>
        </p>
      </div>
    </div>
  );
}

export default SectionFAQ;
